import { cn } from './cn'

/**
 * The bar down the leading edge of the open entry of a list or a navigation.
 *
 * One mark for every level of the Internal area — the rail, the System
 * column, every table row — so "this is what the pane is showing" reads the
 * same wherever the reader meets it. Inset and rounded, because it belongs to
 * the entry and not to the column it sits in.
 *
 * The row it marks needs `relative`, and the ground under it stays with the
 * caller. `className` carries the ink, for a surface the accent cannot be read
 * on.
 */
export function SelectionMarker({ className }: { className?: string }) {
  return (
    <span
      aria-hidden
      className={cn(
        'absolute inset-y-1.5 left-0 w-0.5 rounded-r bg-primary',
        className,
      )}
    />
  )
}
